import React, { useEffect, useRef, useState }  from "react";
import Popup from "reactjs-popup";
import 'reactjs-popup/dist/index.css';
import {GoSearch} from "react-icons/go";
import * as FaIcons from "react-icons/fa";
import "./Analysis.css";
import axios from "axios";
// import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getSimilarity } from "calculate-string-similarity";
import { tcRatingToLetter, userRatingToLetter, compRatingToLetter } from "../MyDocuments/RatingConverter.js";
import { C_ID_UPDATED,
        //  C_UTC_UPDATED,
        //  C_URATE_UPDATED,
        //  C_CRATE_UPDATED,
        //  C_UCRATE_UPDATED,
         C_UPDATED,
        //  C_INVALIDATED,
         C_SET_LEFT_RFS,
         C_SET_RIGHT_RFS,
        } from "../../Constants/cConstants.js"

/* Red flags in previous file but not in new file*/

// const fetchDataDocument = async (documentID) => {
//   try {
//     const response = await axios.get(`/api/v1/tcs/full/${documentID}`);
//       if (response.data.success) {
//         return response.data.FullData;
//       } else {
//         console.error("Failed to get doc data");
//         return null;
//       }
//   }catch (error) {
//     console.error("Failled to get doc data", error);
//     return null;
//   }
// }



const GetText = (txt, analysis, prevRedFlags) => {
  let text = txt;

  prevRedFlags.sort((a,b) => {
    if (a.locL < b.locL) return -1;
    if (a.locL > b.locL) return 1;
    return 0;
  })

  const index = [];
  for (let i = 0; i < prevRedFlags.length; i++) {
    index.push(prevRedFlags[i].locL);
  }

  const handleClick = (ref) => {
    console.log(ref);
    if (ref) {ref.scrollIntoView({ behavior: 'smooth' });}
  }

  const childNodes = [];
  let currIndex = 0;

  if(prevRedFlags.length === 0) {
    childNodes.push(<span>{text}</span>);
    return React.createElement("div", {className:"documentText"}, childNodes);
  }

  for (let i = 0; i < index.length; i++) {
    if (currIndex < index[i]) {
      childNodes.push(<span key={"sn"+i}>
      {text.substring(currIndex, index[i])}</span>);
      currIndex = index[i];
    }
    if (currIndex < prevRedFlags[i].locR) {
      childNodes.push(<span key={"sf"+i} className="compareHighlight" ref={(element) => prevRedFlags[i].ref = element}
      onClick={() => handleClick(prevRedFlags[i].oref)}>
      {text.substring(currIndex, prevRedFlags[i].locR)}</span>);
      currIndex = prevRedFlags[i].locR;
    }
  }
  return React.createElement("div", {className:"documentText"}, childNodes);
}

const PopupCompare = ({closeFunction, getActiveDocId, setActiveDoc}) => {
  // const navigate = useNavigate();
  // const dispatch = useDispatch();
  const { isAuth, user } = useSelector((state) => state.user);
  const [docNameId, docCompanyId, docTypeId, docUploadDateId, docDateSignedId, docRatingId] = [0,1,2,3,4,5];

  /*
    Active tab:
    Positive number means how to sort/Negative number means reverse the sort
    0: order of documents in file
    1: sort by document name
    2: sort by document type
    3: sort by upload date
    4: sort by document rating
  */
  const [activeTab, setActiveTab] = useState(docUploadDateId);
  const [activePage, setPage] = useState(0);
  const [searchName, setSearchName] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [startDoc, setStartDoc] = useState(0);
  const [list, setList] = useState([]);
  const [completeList, setCompleteList] = useState([]);

  const updateDocs = async () => {
    axios({
      method: 'get',
      url: 'api/v1/tcs/mydocs',
      baseURL: '/',
    })
    .then((response) => {
      const copyListOfDocs = [...(response.data.docs)];
      copyListOfDocs.sort((a,b) => {
        if (a.dateUploaded < b.dateUploaded) return 1;
        if (a.dateUploaded > b.dateUploaded) return -1;
        return 0;
      })
      setList(copyListOfDocs);
      setCompleteList(copyListOfDocs);
      // console.log(copyListOfDocs);
      setActiveTab(0);
      setPage(0);
      setSearchName("");
      // if (getActiveDoc() === null) {setActiveDoc(copyListOfDocs[0]);}
      setStartDoc(0);
    })
    .catch(function (error){
      console.log("error getting docs");
    });
  }

  useEffect(() => {
    if (!isAuth) {
      alert("Please Login to compare your documents");
    }
    if (isAuth && user) {
      updateDocs();
      // axios.get('api/v1/tcs/mydocs')
      // .then((response) => {
      //   updateDocs();
      // })
      // .catch(function (error){
      //   console.log("error getting docs");
      // });
    }
  }, [isAuth, user]);


  const getActiveTab = () => {
    return activeTab;
  }

  let docsFound = 0;
  const pageList = [];
  for (let i = 0; i < Math.ceil(list.length/10); i++) {
    pageList.push(i);
  }

  const handleSearch = () => {
    setSearchName(searchKey);
    setList(completeList.filter(doc => (doc.name.toLowerCase().includes(searchKey.toLowerCase()))));
    handlePageBtn(0);
  }

  const handleSearchEnter = (e) => {
    if (e.code === "Enter"){
      setSearchName(searchKey);
      setList(completeList.filter(doc => (doc.name.toLowerCase().includes(searchKey.toLowerCase()))));
      handlePageBtn(0);
    }
  }

  const handleSearchUpdate = (name) => {
    setSearchKey(name);
  }

  const handleSortByName = () => {
    console.log("Sort by document name for docID " + docNameId);
    const copyList = [...list];
    
    if (activeTab === docNameId) {
      copyList.reverse();
    } else {
      setActiveTab(docNameId);
      copyList.sort((a,b) => {
        if(a.name.toLowerCase() < b.name.toLowerCase()) return -1;
        if(a.name.toLowerCase() > b.name.toLowerCase()) return 1;
        return 0;
      })
    }
    setPage(0);
    setStartDoc(0);
    setList(copyList);
  }

  const handleSortByCompany = () => {
    console.log("Sort by document company");
    const copyList = [...list];
    
    if (activeTab === docCompanyId) {
      copyList.reverse();
    } else {
      setActiveTab(docCompanyId);
      copyList.sort((a,b) => {
        if(a.company.toLowerCase() < b.company.toLowerCase()) return -1;
        if(a.company.toLowerCase() > b.company.toLowerCase()) return 1;
        return 0;
      })
    }
    setPage(0);
    setStartDoc(0);
    setList(copyList);
  }

  const handleSortByType = () => {
    console.log("Sort by document type");
    const copyList = [...list];
    
    if (activeTab === docTypeId) {
      copyList.reverse();
    } else {
      setActiveTab(docTypeId);
      copyList.sort((a,b) => {
        if(a.contractType.toLowerCase() < b.contractType.toLowerCase()) return -1;
        if(a.contractType.toLowerCase() > b.contractType.toLowerCase()) return 1;
        return 0;
      })
    }
    setPage(0);
    setStartDoc(0);
    setList(copyList);
  }

  const handleSortByUploadDate = () => {
    console.log("Sort by upload date");
    const copyList = [...list];
    
    if (activeTab === docUploadDateId) {
      copyList.reverse();
    } else {
      setActiveTab(docUploadDateId);
      copyList.sort((a,b) => {
        if (a.dateUploaded < b.dateUploaded) return 1;
        if (a.dateUploaded > b.dateUploaded) return -1;
        return 0;
      })
    }
    
    setPage(0);
    setStartDoc(0);
    setList(copyList);
  }

  const handleSortByDateSigned = () => {
    console.log("Sort by signed date");
    const copyList = [...list];
    
    if (activeTab === docDateSignedId) {
      copyList.reverse();
    } else {
      setActiveTab(docDateSignedId);
      copyList.sort((a,b) => {
        if (a.dateSigned === undefined) {
          if (b.dateSigned === undefined) {
            if (a.dateUploaded < b.dateUploaded) return 1;
            if (a.dateUploaded > b.dateUploaded) return -1;
            // if(a.uploadYear < b.uploadYear) return 1;
            // if(a.uploadYear > b.uploadYear) return -1;
            // if(a.uploadMonth < b.uploadMonth) return 1;
            // if(a.uploadMonth > b.uploadMonth) return -1;
            // if(a.uploadDay < b.uploadDay) return 1;
            // if(a.uploadDay > b.uploadDay) return -1;
            return 0;
          }
          return 1;
        }
        if (b.dateSigned === undefined) { 
          return -1;
        }
        if(a.dateSigned < b.dateSigned) return 1;
        if(a.dateSigned > b.dateSigned) return -1;
        
        return 0;
      })
    }
    setPage(0);
    setStartDoc(0);
    setList(copyList);
  }

  const handleSortByRating = () => {
    console.log("Sort by document rating");
    const copyList = [...list];
    
    if (activeTab === docRatingId) {
      copyList.reverse();
    } else {
      setActiveTab(docRatingId);
      copyList.sort((a,b) => {
        if(a.tcRating < b.tcRating) return -1;
        if(a.tcRating > b.tcRating) return 1;
        return 0;
      })
    }
    setPage(0);
    setStartDoc(0);
    setList(copyList);
  }

  // Select Page buttons
  const handlePrevBtn = () => {
    handlePageBtn(activePage-(activePage % 5) - 1);
  }
  const handleNextBtn = () => {
    handlePageBtn(activePage - (activePage % 5) + 5);
  }
  const handlePageBtn = (index) => {
    setPage(index);
    setStartDoc(index*10);
    docsFound = 0;
  }

  const handleChangeDocument = () => {
    closeFunction(false);
  }

  return (
    <div className="searchCompare">
        <div className="searchBarCompare">
          <input className="searchTextCompare" id="searchText" placeholder="Search My Documents"
            onChange={e => handleSearchUpdate(e.target.value)} onKeyDown={e => handleSearchEnter(e)}></input>
            <GoSearch className="searchIcon" onClick={handleSearch}/>
        </div>
        <table className="searchTableCompare">
          <thead key="tableHeadCompare">
            <tr className="tableRowHeading" key="heading">
              <th className="nameTabCompare" key={"DocName"} isactive={docNameId===Math.abs(activeTab)}>
                <Tab id={docNameId} sort={handleSortByName} type={"Name"} activeTab={getActiveTab}/></th>
              <th className="companyTabCompare" key={"CompanyName"} isactive={docCompanyId===Math.abs(activeTab)}>
                <Tab id={docCompanyId} sort={handleSortByCompany} type={"Company"} activeTab={getActiveTab}/></th>
              <th className="typeTabCompare" key={"DocType"} isactive={docTypeId===Math.abs(activeTab)}>
                <Tab id={docTypeId} sort={handleSortByType} type={"Type"} activeTab={getActiveTab}/></th>
              <th className="uploadTabCompare" key={"DocUpload"} isactive={docUploadDateId===Math.abs(activeTab)}>
                <Tab id={docUploadDateId} sort={handleSortByUploadDate} type={"Upload Date"} activeTab={getActiveTab}/></th>
              <th className="signedTabCompare" key={"DocSigned"} isactive={docDateSignedId===Math.abs(activeTab)}>
                <Tab id={docDateSignedId} sort={handleSortByDateSigned} type={"Date Signed"} activeTab={getActiveTab}/></th>
              <th className="ratingTabCompare" key={"DocRating"} isactive={docRatingId===Math.abs(activeTab)}>
                <Tab id={docRatingId} sort={handleSortByRating} type={"Rating"} activeTab={getActiveTab}/></th>
            </tr>
          </thead>

          <tbody key="tableBodyCompare">
            {list.length > 0 && list.map((doc, index) => {
              if (docsFound < 10 && startDoc <= index) {
                if (doc.name.toLowerCase().includes(searchName.toLowerCase())) {
                  docsFound++;
                  return (
                    <tr className={getActiveDocId() === doc._id ? "tableRowCompare active" : "tableRowCompare"} onClick={()=>setActiveDoc(doc)} key={"Row"+index}>
                      <td className="nameTab" key={"name"+index}>{doc.name}</td>
                      <td className="companyTab" key={"company"+index}>{doc.company}</td>
                      <td className="typeTab" key={"type"+index}>{doc.contractType}</td>
                      <td className="uploadTab" key={"upload"+index}>
                        {((new Date(doc.dateUploaded)).getMonth()+1) +"/"+ (new Date(doc.dateUploaded)).getDate() +"/" + (new Date(doc.dateUploaded)).getFullYear() }</td>
                      <td className="signedTab" key={"signed"+index}>
                        {doc.dateSigned !== undefined ? ((new Date (doc.dateSigned)).getMonth()+1) +"/"+ (new Date(doc.dateSigned)).getDate() +"/"+(new Date(doc.dateSigned)).getFullYear() : "X"}</td>
                      <td className="optionsTab" key={doc.tcRating+doc._id+index}>{tcRatingToLetter(doc.tcRating)}</td>
                    </tr>
                  );
                }
              }
              return "";
            })}
          </tbody>
        </table>
        <div className="pageBtns">
            <button className="compareUploadBtn" onClick={handleChangeDocument}>Change Contract</button>

          <div className="pageBtnList">
            <p className={activePage < 5 ? "pageBtn inactive" : "pageBtn"} key={"prevBtn"} onClick={handlePrevBtn}>Prev</p>
            {pageList.length > 0 && pageList.map((element) => {
              if (activePage - (activePage % 5) <= element && element <= activePage - (activePage % 5) + 4) {
                return <p className={element === activePage ? "pageBtn active" : "pageBtn"} key={"page"+(element+1)}
                  onClick={()=>handlePageBtn(element)}>{element + 1}</p>;
              }
              return "";
            })}
            <p className={(activePage - activePage % 5) + 5 >= pageList.length ? "pageBtn inactive" : "pageBtn"}
              key={"nextBtn"} onClick={handleNextBtn}>Next</p>
          </div>
        </div>
      </div>
    );
  }

const Compare = () => {
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  // const params = useParams();

  const { tc, analysis } = useSelector((state) => state.tc);
  const { c_id, c_tc, c_gtc, c_comp, c_analysis, c_r_red_flags, c_l_red_flags } = useSelector((state) => state.compare);
  // const x = useSelector((state) => console.log(state));
  const { isAuth } = useSelector((state) => state.user);

  // the actual red flags of the left and right documents
  const [nonCompedLeftRFs, setNonCompedLeftRFs] = useState([]);
  const [nonCompedRightRFs, setNonCompedRightRFs] = useState([]);

  //the results of comparing the red flags for the left and right documents
  const [currRedFlags, setCurrRedFlags] = useState([]);//default highlights for left doc
  const [prevRedFlags, setPrevRedFlags] = useState([]);//default highlights for right doc
  
  const [activeFlags, setActiveFlags] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  // const [activeDoc, setActiveDoc] = useState(null);
  const [isOpenKey, setIsOpenKey] = useState(false);
  const [content, setContent] = useState("default");
  // const [isSaved, setIsSaved] = useState(true);

  const [docName, setDocName] = useState("No Name Specified");
  const [contractType, setContractType] = useState("No Contract Specified");
  const [product, setProduct] = useState("No Product Specified");
  const [company, setCompany] = useState("No Company Specified");
  const [companyRating, setCompanyRating] = useState(" ");
  const [documentRating, setDocumentRating] = useState(" ");
  const [userRating, setUserRating] = useState(" ");
  const [dateUploaded, setDateUploaded] = useState("yyyy-mm-dd");
  
  // const updateDocs = async () => {
  //   axios({
  //     method: 'get',
  //     url: 'api/v1/tcs/mydocs',
  //     baseURL: '/',
  //   })
  //   .then((response) => {
  //     const copyListOfDocs = [...(response.data.docs)];
  //     copyListOfDocs.sort((a,b) => {
  //       if (a.dateUploaded < b.dateUploaded) return 1;
  //       if (a.dateUploaded > b.dateUploaded) return -1;
  //       return 0;
  //     })
  //     if (activeDoc === null) {
  //       setActiveDoc(copyListOfDocs[0]);
  //     }
  //   })
  //   .catch(function (error){
  //     console.log("error getting docs");
  //   });
  // }

  // useEffect(() => {
  //   if (!isAuth) {
  //     navigate('/');
  //   }
  //   if (isAuth && user) {
  //     updateDocs();
  //     // axios.get('api/v1/tcs/mydocs')
  //     // .then((response) => {
  //     //   updateDocs();
  //     // })
  //     // .catch(function (error){
  //     //   console.log("error getting docs");
  //     // });
  //   }
  // }, [isAuth, user]);

  // //sets comparison document (right side) to nearest version of the left document.
  // const setRightDocToNearestVersion = () => {
  //   if (isSaved && gtc !== null){
  //     const response = axios({
  //         method: 'get',
  //         url: `api/v1/tcs/versions/${gtc._id}`,
  //         baseURL:'/',
  //     })
  //     .then((response) => {
  //       if (response.data.success){
  //         const docId = findNearestVerId(response.data.versions);
  //         if (docId !== null) {
  //           dispatch({ type: C_ID_UPDATED, payload: { c_id: docId } });
  //         }
  //       } else {
  //         throw Error("Failed to retrieve all versions of contract");
  //       }
  //     })
  //     .catch((error) => {
  //       alert("Failed to retrieve all versions of your contract");
  //     });
  //   }
  // };

  // //returns null if no other versions of contract exist.
  // const findNearestVerId = (versions) => {
  //   if (versions.length >= 2){
  //     let doc_id;
  //     if (versions[0]._id === tc._id){
  //         doc_id = versions[1]._id;
  //     } else {
  //         doc_id = versions[0]._id;
  //     }
  //     return doc_id;
  //   } else {
  //     return null;
  //   }
  // }

  // // useEffect(() => {
  // //   setIsSaved(!(unsaveds.hasOwnProperty(params.tcid)));
  // // }, [unsaveds]);

  // useEffect(() => {

  //   setRightDocToNearestVersion();

  // }, [tc, isSaved]);

  useEffect(() => {
    if (analysis){
      setNonCompedLeftRFs(analysis.redflags);
    } else {
      setNonCompedLeftRFs([]);
    }
  }, [analysis]);

  useEffect(() => {
    if (c_tc){
        setDocumentRating(tcRatingToLetter(c_tc.tcRating));
        setDocName(c_tc.name);
        setContractType(c_tc.contractType);
        if (c_tc.product){
            setProduct(c_tc.product);
        } else {
            setProduct("No Product Specified");
        }

        if (c_tc.company){
            setCompany(c_tc.company);
        } else {
            setCompany("No Company Specified");
        }

        if (c_tc.dateUploaded){
            const uploadDate = new Date(tc.dateUploaded);
            const y = uploadDate.getFullYear();
            const m = (uploadDate.getMonth()+1) <= 9 ? "0"+(uploadDate.getMonth()+1) : uploadDate.getMonth()+1;
            const d = uploadDate.getDate() <= 9 ? "0"+uploadDate.getDate() : uploadDate.getDate();
            setDateUploaded(y + "-" + m + "-" + d);
        } else {
            setDateUploaded("yyyy-mm-dd");
        }
    }
    // eslint-disable-next-line
  }, [c_tc]);
  
  useEffect(() => {
    async function setCompDoc(){
      try {
          // const response = await fetch('api/v1/documents/${documentID}/versions');
          // const data = await response.json();
          const response = await axios({
              method: 'get',
              url: `api/v1/tcs/full/${c_id}`,
              baseURL:'/',
          });
          if (response.data.success){
            dispatch({ type: C_UPDATED, payload: response.data.fullData });
          }
      }
      catch (error){
          console.log("Error retrieving doc", error);
      }
    };

    if (isAuth && (c_id !== null)){
        // console.log("cid: " + c_id);
        setCompDoc();
    }
  }, [c_id, isAuth, dispatch]);

  useEffect(() => {
    if (c_analysis){
        setContent(c_analysis.content);
        // console.log("analysis triggered");
        // console.log(c_analysis.redflags);
        setNonCompedRightRFs(c_analysis.redflags);
        // setPrevRedFlags(c_analysis.redflags);
        // console.log(content);
    } else {
        setContent("No associated analysis");
        setNonCompedRightRFs([]);
        // setPrevRedFlags([]);
    }
  }, [c_analysis]);

  useEffect(() => {
    //DO YOUR COMPARISON WORK HERE
    if (nonCompedLeftRFs && nonCompedRightRFs){
      const threshold = 80;//0.8;
      const uniqueLeft = nonCompedLeftRFs.filter((leftFlag) => {
        let redFlagsSimilar = {flag: null, similarity: 0};
        nonCompedRightRFs.forEach((rightFlag) => {
          const similarity = getSimilarity(
            leftFlag.summary,
            rightFlag.summary
          );
          if (similarity > redFlagsSimilar.similarity){
            redFlagsSimilar.flag = rightFlag;
            redFlagsSimilar.similarity = similarity;
          }
        });
        return redFlagsSimilar.similarity < threshold;
      });

      const uniqueRight = nonCompedRightRFs.filter((rightFlag) => {
        let redFlagsSimilar = {flag: null, similarity: 0};
        nonCompedLeftRFs.forEach((leftFlag) => {
          const similarity = getSimilarity(
            rightFlag.summary,
            leftFlag.summary
          );
          if (similarity > redFlagsSimilar.similarity){
            redFlagsSimilar.flag = leftFlag;
            redFlagsSimilar.similarity = similarity;
          }
        });
        return redFlagsSimilar.similarity < threshold;
      });

      dispatch({type: C_SET_LEFT_RFS, payload: uniqueLeft});
      dispatch({type: C_SET_RIGHT_RFS, payload: uniqueRight});
    }
    else {
      console.log("Current Right Red Flags or Current Left Red Flags in null");
    }
  }, [nonCompedLeftRFs, nonCompedRightRFs, dispatch]);

  //automatically sets currRedFlags to c_l_red_flags when c_l_red_flags changes
  useEffect(() => {
    if (c_l_red_flags){
      c_l_red_flags.sort((a,b) => {
        if (a.locL < b.locL) return -1;
        if (a.locL > b.locL) return 1;
        return 0;
    })
      setCurrRedFlags(c_l_red_flags);
    } else {
      setCurrRedFlags([]);
    }
  }, [c_l_red_flags]);

  //automatically sets prevRedFlags to c_r_red_flags when c_r_red_flags changes
  useEffect(() => {
    if (c_r_red_flags){
      // console.log("RightRFS");
      // console.log(c_r_red_flags);
      // console.log(c_analysis);
      // console.log(nonCompedRightRFs);
      c_r_red_flags.sort((a,b) => {
        if (a.locL < b.locL) return -1;
        if (a.locL > b.locL) return 1;
        return 0;
      })
      setPrevRedFlags(c_r_red_flags);
    } else {
      // console.log("RightRFSNULL");
      setPrevRedFlags([]);
    }
  }, [c_r_red_flags]);

  useEffect(() => {
    // console.log(gtc)
    // console.log(comp)
    if (c_gtc){
        setUserRating(userRatingToLetter(c_gtc.userRating));
    } else {
        setUserRating(" ");
    }

    if (c_comp){
        setCompanyRating(compRatingToLetter(c_comp.companyRating));
        // console.log("company rating changed");
    } else {
        setCompanyRating(" ");
    }

  }, [c_gtc, c_comp ]);
  
  const getActiveDocId = () => {
    return c_id;
  }
  const popupSetActiveDoc = (doc) => {
    dispatch({ type: C_ID_UPDATED, payload: { c_id: doc._id } });
  }

  const closePopUp = () => {
      setIsOpen(false);
  }

  const openKeyRating = () => {
      console.log("Open pop up to see rating key");
  }

  const severities = {
    high: "severeRF",
    medium: "mediumRF",
    low: "lowRF",
  };

  const getSeverity = (element) => {
    return severities[element.hasOwnProperty("severity") ? element.severity : "medium"];
  };

  const severeList = [];
  const mediumList = [];
  const lowList = [];
  const redFlagCounter = [0,0,0,0,0,0];
  const severeRef = useRef();
  const mediumRef = useRef();
  const lowRef = useRef();
  const handleClick = (ref) => {
    console.log(ref);
    if (ref) {ref.scrollIntoView({ behavior: 'smooth' });}
  }

  currRedFlags.map((element, index) => {
    if (getSeverity(element) === "severeRF") {
      redFlagCounter[0]++;
      severeList.push(<li key={"previous"+index} className="rfdItemRed"
        onClick={()=>handleClick(element.ref)} ref={(element) => {currRedFlags[index].oref = element}}
        ><span>{element.summary}</span><FaIcons.FaPlus className="redFlagIcon"/></li>);
    } else if (getSeverity(element) === "mediumRF") {
      redFlagCounter[1]++;
      mediumList.push(<li key={"previous"+index} className="rfdItemRed"
        onClick={()=>handleClick(element.ref)} ref={(element) => {currRedFlags[index].oref = element}}
        ><span>{element.summary}</span><FaIcons.FaPlus className="redFlagIcon"/></li>);
    } else if (getSeverity(element) === "lowRF") {
      redFlagCounter[2]++;
      lowList.push(<li key={"previous"+index} className="rfdItemRed"
        onClick={()=>handleClick(element.ref)} ref={(element) => {currRedFlags[index].oref = element}}
        ><span>{element.summary}</span><FaIcons.FaPlus className="redFlagIcon"/></li>);
    }
    return "";
  })
  prevRedFlags.map((element, index) => {
    if (getSeverity(element) === "severeRF") {
      redFlagCounter[3]++;
      severeList.push(<li key={"previous"+index} className="rfdItemGreen"
        onClick={()=>handleClick(element.ref)} ref={(element) => {prevRedFlags[index].oref = element}}
        ><span>{element.summary}</span><FaIcons.FaMinus className="redFlagIcon"/></li>);
    } else if (getSeverity(element) === "mediumRF") {
      redFlagCounter[4]++;
      mediumList.push(<li key={"previous"+index} className="rfdItemGreen"
        onClick={()=>handleClick(element.ref)} ref={(element) => {prevRedFlags[index].oref = element}}
        ><span>{element.summary}</span><FaIcons.FaMinus className="redFlagIcon"/></li>);
    } else if (getSeverity(element) === "lowRF") {
      redFlagCounter[5]++;
      lowList.push(<li key={"previous"+index} className="rfdItemGreen"
        onClick={()=>handleClick(element.ref)} ref={(element) => {prevRedFlags[index].oref = element}}
        ><span>{element.summary}</span><FaIcons.FaMinus className="redFlagIcon"/></li>);
    }
    return "";
  })

  return (
    <div className="compareResults">
      <p className="resultsExplanation">Compare the contract with a similar contract you’ve uploaded or a previous version of the contract</p>
        <div className="redFlagsCount">
          <p className="redFlagsCountLeft"><Triangle setState={setActiveFlags}/><span className="RFCount">Red Flags <span className="redCount">{"+" + currRedFlags.length}</span><span className="greenCount">{"+" + prevRedFlags.length}</span></span></p>
          <p className="redFlagsCountRight">
            <span className="RFCount" onClick={()=>handleClick(severeRef.current)}>Severe <span className="redCount">{"+"+redFlagCounter[0]}</span><span className="greenCount">{"+"+redFlagCounter[3]}</span></span>
            <span className="RFCount" onClick={()=>handleClick(mediumRef.current)}>Medium <span className="redCount">{"+"+redFlagCounter[1]}</span><span className="greenCount">{"+"+redFlagCounter[4] }</span></span>
            <span className="RFCount" onClick={()=>handleClick(lowRef.current)}>Low <span className="redCount">{"+"+redFlagCounter[2]}</span><span className="greenCount">{"+"+redFlagCounter[5]}</span></span>
          </p>
        </div>
        <div className={activeFlags ? "redFlagsDiffActive": "redFlagsDiffInactive"}>
          <span className="redFlagsDiffHeading" ref={severeRef}>
            <span className="RFType">Severe</span><span className="redCount">{"+"+redFlagCounter[0]}</span>
            <span className="greenCount">{"+"+redFlagCounter[3]}</span>
          </span>
            {severeList.map((element) => {
              return element;
            })}
            <span className="redFlagsDiffHeading" ref={mediumRef}><span className="RFType">Medium</span>
              <span className="redCount">{"+"+redFlagCounter[1]}</span><span className="greenCount">{"+"+redFlagCounter[4]}</span></span>
            {mediumList.map((element) => {
              return element;
            })}
            <span className="redFlagsDiffHeading" ref={lowRef}><span className="RFType">Low</span>
              <span className="redCount">{"+"+redFlagCounter[2]}</span><span className="greenCount">{"+"+redFlagCounter[5]}</span></span>
            {lowList.map((element) => {
              return element;
            })}      
        </div>
        <div className={activeFlags ? "documentSide-previous": "documentSide-previous-active"}>

          <div className="documentHeading"> 
            <div className="contractInfo">
              <h2>Name: {docName}</h2>
              <h2>Contract type: {contractType}</h2>
              <h2>Product: {product}</h2>
              <h2>Company: {company}</h2>
              <h2>Date Uploaded: {dateUploaded}</h2>
            </div>
            <div className="rating">
              <h2><span className="ratingResults">Document Rating </span><span className={documentRating[0] + " grade"}>{documentRating}</span></h2>
              <h2><span className="ratingResults">User Rating </span><span className={userRating[0] + " grade"}>{userRating}</span></h2>
              <h2><span className="ratingResults">Company Rating </span><span className={companyRating[0] + " grade"}>{companyRating}</span></h2>
              <Popup className="ratingKeyPopUp" contentStyle={{width: "60%"}} on="click"
                open={isOpenKey} onOpen={() => setIsOpenKey(false)}
                trigger= {<h2 className="ratingKeyLine">See Rating Key <FaIcons.FaBars className="openRating" onClick={openKeyRating}/></h2>} 
                modal nested>
                {
                    close => (
                        <div className="ratingKey">T&C Rating scale is based on a score calculated from the intensity and prevalence of red flags.<br/>
                            <ul>
                                <li>A: 0-15 (Safe)</li><br/>
                                <li>B: 16-40</li><br/>
                                <li>C: 41-70</li><br/>
                                <li>D: 71-90</li><br/>
                                <li>F: 90-100 (Unsafe)</li><br/>
                            </ul>
                            User Rating scale is the average rating by users on how safe this contract is.<br/>
                            <ul>
                                <li>A: Safe</li><br/>
                                <li>B: Relatively safe</li><br/>
                                <li>C: Neither safe nor unsafe</li><br/>
                                <li>D: Unsafe</li><br/>
                                <li>F: Very unsafe</li>
                            </ul>
                        </div>
                    )
                }
              </Popup>
            </div>
          </div>

          {GetText(content, analysis, prevRedFlags)}
          
        </div>
        <Popup className="docChoose" contentStyle={{width: "60%"}} on="click"
            open={isOpen} onOpen={() => setIsOpen(!isOpen)}
            trigger={<button className="docChoose"> Compare with another contract </button>} 
            modal nested>
          {
            close => (
                <div className='modal'>
                <PopupCompare closeFunction={closePopUp} getActiveDocId={getActiveDocId} setActiveDoc={popupSetActiveDoc}/>
              </div>
            )
          }
          </Popup>
    </div>
  );
};

const Triangle = ({setState}) => {
  const [active, setActive] = useState(true);
  const handleClick = (e) => {
      setActive(e);
      setState(e);
  }

  if (active) {
      return <FaIcons.FaCaretDown className="caret" onClick={()=>handleClick(false)}/> 
  }
  return <FaIcons.FaCaretRight className="caret" onClick={()=>handleClick(true)}/> 
}

const Tab = ({id, sort, type, activeTab}) => {
  // [INACTIVE, DOWN, UP ] = [0,1,2]
  const [active, setActive] = useState(0);
  const handleClick = (e) => {
    sort();
    setActive(e);
  }
  if (activeTab() !== id && active !== 0) {
    setActive(0);
    return <span onClick={()=>handleClick(1)}>{type}<FaIcons.FaSort/></span>;
  }
  if (activeTab() === id) {
    if (active === 1) {
      return <span onClick={()=>handleClick(2)}>{type}<FaIcons.FaCaretDown/></span>;
    }
    if (active === 2){
      return <span onClick={()=>handleClick(1)}>{type}<FaIcons.FaCaretUp/></span>;
    }
  }
  return <span onClick={()=>handleClick(1)}>{type}<FaIcons.FaSort/></span>;
}

export default Compare;